import cn from 'classnames'
import {FC} from 'react'

import {MobileNavigation} from '@/components/header/MobileNavigation'
import {SearchInput} from '@/components/inputs/SearchInput'
import {useCommonContent} from '@/content/common'
import {useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE} from '@/utils/styles/breakpoints'

type KnowledgeBaseMobileNavigationProps = {
  title: string
  query: string
  setQuery: (query: string) => void
  isActive: boolean
  toggleNavigation: () => void
  hasResults: boolean
}

export const KnowledgeBaseMobileNavigation: FC<
  React.PropsWithChildren<KnowledgeBaseMobileNavigationProps>
> = ({title, query, setQuery, isActive, toggleNavigation, hasResults, children}) => {
  const {t} = useTranslation()
  const {searchPlaceholder} = useCommonContent()

  return (
    <>
      <MobileNavigation isActive={isActive} toggleNavigation={toggleNavigation} title={title}>
        <div className="search-wrapper">
          <SearchInput
            query={query}
            setQuery={setQuery}
            placeholder={t(searchPlaceholder)}
            color={theme.palette.text.white}
            backgroundColor={theme.palette.tertiary.main}
            borderColor={theme.palette.gray[600]}
            hasBorder
          />
        </div>
        <div className={cn('results', !!query && 'active-search')}>{children}</div>
      </MobileNavigation>

      <style jsx>{`
        .search-wrapper {
          margin-top: ${theme.spacing[4]};
        }
        .results {
          display: flex;
          flex-direction: column;
          overflow-y: auto;
          padding-right: ${theme.spacing[5]};
          margin-right: -${theme.spacing[5]};
          margin-top: ${theme.spacing[4]};
          ${hasResults ? `margin-bottom: -${theme.spacing[5]}` : ''};
        }
        .results::-webkit-scrollbar-track {
          width: 4px;
          background-color: ${theme.palette.tertiary.main};
        }
        .results::-webkit-scrollbar {
          width: 4px;
          background-color: ${theme.palette.tertiary.main};
        }
        .results::-webkit-scrollbar-thumb {
          width: 4px;
          border-radius: 8px;
          background-color: ${theme.palette.gray[300]};
        }
        @media ${MOBILE_SCREENSIZE} {
          .active-search {
            min-height: 50vh;
            min-height: 50svh;
          }
        }
      `}</style>
    </>
  )
}
